import { CameraIcon } from 'lucide-react';
import { CompareSlider } from '../../../ui/CompareSlider';
import { useSite } from '../../../contexts/SiteContext';
import { dayShort, diaryWeek } from '../../../utils/account';
import { btnPrimary, inputCls } from '../../../ui/styles';
import type { DiaryEntry } from '../../../core/types/account';
type Props = {
  entries: DiaryEntry[];
  before?: DiaryEntry;
  after?: DiaryEntry;
  onBefore: (id: string) => void;
  onAfter: (id: string) => void;
  onNewPhoto: () => void;
};

/** Twee foto's naast elkaar met een schuif. Links en rechts kunnen nooit dezelfde foto zijn. */
export function DiaryCompare({
  entries,
  before,
  after,
  onBefore,
  onAfter,
  onNewPhoto
}: Props) {
  const {
    policy
  } = useSite();
  const start = entries[0]?.date;
  const weekOf = (e: DiaryEntry) => diaryWeek(start, e.date);
  if (!before || !after || before.id === after.id) {
    return <div className="flex aspect-[4/5] flex-col items-center justify-center bg-shell p-8 text-center ring-1 ring-line" data-id="element-6429" data-mp="21zux32zmy3bv">
        <CameraIcon className="h-6 w-6 text-muted" strokeWidth={1.5} aria-hidden="true" data-id="element-6430" data-mp="1lc1kzyriko26" />
        <p className="mt-3 text-[15px] text-ink" data-id="element-6431" data-mp="1pctvevc4gz01">{entries.length ? 'Nog één foto nodig om te vergelijken.' : 'Je dagboek is nog leeg.'}</p>
        <p className="mt-1 max-w-xs text-[14px] leading-relaxed text-muted" data-id="element-6432" data-mp="1udhpxqzk7xz0">
          {entries.length ? `Maak over ${policy.diaryEveryDays} dagen je volgende foto, dan zie je hier het verschil.` : 'Maak vandaag je startfoto. Zonder begin zie je later niet hoe ver je gekomen bent.'}
        </p>
        <button type="button" onClick={onNewPhoto} className={`${btnPrimary} mt-5`} data-id="element-6433" data-mp="16kj5s36haxjv">
          <CameraIcon className="h-4 w-4" strokeWidth={1.5} aria-hidden="true" data-id="element-6434" data-mp="1bk47umgy3m0t" />
          {entries.length ? 'Nieuwe foto' : 'Startfoto maken'}
        </button>
      </div>;
  }
  const sides = [{
    id: 'diary-left',
    label: 'Links',
    value: before.id,
    other: after.id,
    set: onBefore
  }, {
    id: 'diary-right',
    label: 'Rechts',
    value: after.id,
    other: before.id,
    set: onAfter
  }];
  return <>
      <CompareSlider key={`${before.id}-${after.id}`} before={{
      image: before.image,
      label: `Week ${weekOf(before)}`
    }} after={{
      image: after.image,
      label: `Week ${weekOf(after)}`
    }} data-id="element-6435" data-mp="ftlr1zwj0nje" />
      <div className="mt-4 grid grid-cols-2 gap-3" data-id="element-6436" data-mp="pkq42u2n5ybl">
        {sides.map(s => <div key={s.id} data-id="element-6437" data-mp="kn6eiy0htz4c">
            <label htmlFor={s.id} className="block text-[13px] text-muted" data-id="element-6438" data-mp="kmwwpxplqy9q">
              {s.label}
            </label>
            <select id={s.id} value={s.value} onChange={e => s.set(e.target.value)} className={`${inputCls} mt-1 py-2.5`} data-id="element-6439" data-mp="3t3rp2j8rx09k">
              {entries.map(e => <option key={e.id} value={e.id} disabled={e.id === s.other} data-id="element-6440" data-mp="6wbd26sbqkas">
                  Week {weekOf(e)} · {dayShort(e.date)}
                </option>)}
            </select>
          </div>)}
      </div>
    </>;
}